import { deserializeAuth } from './lib/deserializeAuth';
import Cookies from 'js-cookie';
import { createGlobalState } from 'react-hooks-global-state';

export const {
  GlobalStateProvider,
  useGlobalState,
  getGlobalState,
  setGlobalState,
} = createGlobalState({
  clockingsAuthUser: deserializeAuth(Cookies.get('clockingsAuthUser')),
});
